import privacy from '@/locales/th/privacy'
import termsOfService from '@/locales/th/terms-of-service'
import spacialRules from '@/locales/th/spacial-rules'
import protocol from '@/locales/th/protocol'
import kycPrivacy from '@/locales/th/kyc-privacy'
import serviceCertification from '@/locales/th/service-certification'

const th = {
  Username: 'Username',
  Password: 'Password',
  login_email: 'Login Email',
  login_password: 'Login Password',
  no_account: 'No account?',
  forget_password: 'ลืมรหัสผ่าน?',
  go_to_register: 'Go to register',
  log_in: 'Log in',
  phone_number: 'Phone number',
  please_enter_phone_number: 'กรุณากรอกหมายเลขโทรศัพท์',
  please_enter_a_new_phone_number: 'กรุณากรอกหมายเลขโทรศัพท์',
  get_code: 'รับรหัส',
  not_my_number: 'ไม่ใช่หมายเลขของฉัน',
  log_out: 'ออกจากระบบ',
  group_of_companies: 'กลุ่มบริษัท',
  log_out_tips: 'คุณได้ออกจากระบบเนื่องจากไม่มีการใช้งาน',
  okay: 'ตกลง',
  sms_verification_code: 'รหัสยืนยันทาง SMS',
  settings: 'Settings',
  profile: 'บัญชี',
  transaction_list: 'รายการธุรกรรม',
  transaction_detail: 'รายละเอียดธุรกรรม',
  fee: 'ค่าธรรมเนียม',
  blue_pay_balance: 'ยอดคงเหลือ BluePay',
  balance: 'ยอดเงิน',
  bluepay_balance: 'BluePay ยอดเงิน',
  available_balance: 'ยอดคงเหลือที่สามารถใช้ได้',
  reserve_balance: 'ยอดคงเหลือที่สำรองไว้',
  withdrawable_balance: 'ยอดคงเหลือที่สามารถถอนออกได้',
  more_info: 'ข้อมูลเพิ่มเติม',
  transferable_balance: ' ยอดเงินที่โอนได้',
  available_amount: 'จำนวนเงินที่สามารถใช้ได้',
  top_up_method: 'วิธีการเติมเงิน',
  estimated_fee: 'ค่าธรรมเนียมโดยประมาณ',
  view_detail: 'ดูรายละเอียด',
  step: 'ขั้นตอนที่',
  add_bank_card: 'เพิ่มบัตรธนาคาร',
  bank_card_detail: 'รายละเอียดบัตรธนาคาร',
  bank: 'ธนาคาร',
  account_name: 'ชื่อบัญชี',
  account_id: 'หมายเลขบัญชี',
  mobile_phone_number: 'หมายเลขโทรศัพท์มือถือ',
  save: 'บันทึก',
  del_bankcard: 'ปิดการใช้งาน',
  my_conected_bank_accounts: 'บัญชีธนาคารที่เชื่อมต่อของฉัน',
  bank_card_limit_1: 'ขณะนี้ยังไม่รองรับการลบบัญชีธนาคารสุดท้าย',
  bank_card_limit_5: 'คุณสามารถเพิ่มบัตรธนาคารได้สูงสุด 5 ใบ',
  del_this_bank: 'ใช่ ปิดการใช้งานบัญชีนี้',
  submit: 'ส่ง',
  complete: 'ส่งเสร็จสิ้น',
  next: 'ถัดไป',
  id_card: 'บัตรประชาชน',
  passport: 'หนังสือเดินทาง',
  other: 'อื่นๆ',
  transaction_date: 'วันที่ซื้อขาย',
  nationality: 'สัญชาติ',
  first_name: 'ชื่อ',
  last_name: 'นามสกุล',
  id_type: 'ประเภท ID',
  reason: 'เหตุผล',
  type: 'ประเภท',
  card_id: 'รหัสบัตร',
  laser_id: 'รหัสหลังบัตรประชาชน',
  resubmit: 'ส่งอีกครั้ง',
  authentication_failed: 'การตรวจสอบสิทธิ์ข้อมูลส่วนบุคคลล้มเหลว, กรุณาลองอีกครั้ง',
  dyna_upload_id_portrait_missing: 'ไม่ตรวจพบภาพถ่ายเอกสาร',
  industry: 'อาชีพ',
  clear: 'ชัดเจน',
  date_of_birth: 'วันเดือนปีเกิด',
  handwritten_signature: 'ลายเซ็นลายมือ',
  id_card_address: 'จังหวัด อำเภอ ตำบล',
  street_address: 'ที่อยู่',
  confirm: 'ยืนยัน',
  total_amount: 'ยอดรวม',
  amount_to_be_paid: 'จำนวนที่ต้องจ่าย',
  logout_account: 'ออกจากระบบ',
  upload_avatar: 'อัพโหลดรูปโปรไฟล์',
  identity_information: 'ข้อมูลของฉัน',
  bank_account: 'บัญชีธนาคารของฉัน',
  promotion: 'บัญชีธนาคารของฉัน',
  mobile_top_up_discount_promo: 'โปรโมชั่นส่วนลดเติมเงินมือถือ',
  expiration: 'วันหมดอายุ',
  use_now: 'ใช้ตอนนี้',
  selected: 'เลือกแล้ว',
  use_conditions: 'เงื่อนไขการใช้งาน',
  unavailable_reason: 'เหตุผลที่ไม่สามารถใช้งานได้',
  close_tip: 'กิจกรรมได้ถูกปิดลงแล้ว',
  useAble_tip: 'เกินขีดจำกัดของการดำเนินกิจกรรมส่งเสริมการขาย',
  off: 'ปิด',
  unlink: 'Unlink',
  notifications: 'Notifications',
  transaction_number: 'Transaction Number',
  problem_description: 'คำอธิบายปัญหา',
  submission_time: 'เวลาส่ง',
  customer_complaint_type: 'ประเภทการร้องเรียนของลูกค้า',
  feedback_and_complaint: 'ข้อเสนอแนะและข้อร้องเรียน',
  view_more: 'ดูเพิ่มเติม',
  history: 'History',
  proceed: 'ดำเนินการต่อ',
  select: 'เลือก',
  bank_name: 'ชื่อธนาคาร',
  bank_account_no: 'Bank Account No.',
  bank_account_holder: 'Bank Account Holder',
  copy_of_bank_passbook_wallet: 'Copy of Bank Passbook/E-wallet',
  old_password: 'Old Password',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  filter: 'Filter',
  status: 'สถานะ',
  reset: 'รีเซ็ต',
  channel: 'Channel',
  transaction_type: 'ประเภทการประมวลผลธุรกรรม',
  details: 'Details',
  amount: 'จำนวน',
  mobile_no: 'เบอร์มือถือ',
  select_amount: 'เลือกจำนวนเงิน',
  method: 'ช่องทางการเติมเงิน',
  account_number: 'หมายเลขบัญชี',
  cash_out_fee: 'ค่าธรรมเนียมการถอนเงิน',
  amount_to_receive: 'จำนวนที่ได้รับ',
  detail_confirmation: 'ยืนยันรายละเอียด',
  tips: 'เคล็ดลับ',
  transaction_details: 'รายละเอียดการทำรายการ',
  max_size_tips: 'ขนาดของภาพไม่สามารถเกิน 20M',
  upload_proof: 'อัปโหลดหลักฐาน',
  upload: 'อัพโหลด',
  up_to: 'สูงสุด',
  download: 'ดาวน์โหลด',
  top_up_amount: 'จำนวนเงินเติม',
  mobile_top_up_amount: 'จำนวนเงินเติม',
  discount_amount: 'จำนวนส่วนลด',
  discount: 'การลดราคา',
  date_and_time: 'วันที่และเวลา',
  top_up_fee: 'ค่าธรรมเนียมการเติมเงิน',
  copied: 'คัดลอกแล้ว!',
  thai_qr_code: 'โค้ด QR ไทย',
  payment_successful: 'การชำระเงินสำเร็จ',
  transaction_processing: 'กำลังดำเนินการธุรกรรม',
  transaction_fee_included: 'ค่าธรรมเนียมการธนาคารรวมใน',
  transaction_fee: 'Transaction Fee',
  payment_channel: 'Payment Channel',
  transaction_id: 'หมายเลขธุรกรรม',
  create_time: 'เวลาสร้าง',
  complete_time: 'เวลาเสร็จสิ้น',
  payer: 'ผู้ชำระเงิน',
  payer_bank: 'ธนาคารผู้ชำระเงิน',
  payer_account: 'บัญชีผู้ชำระเงิน',
  payer_account_name: 'ชื่อบัญชีผู้ชำระเงิน',
  send_to: 'ส่งถึง',
  no_more: 'สิ้นสุด',
  all: 'ทั้งหมด',
  effective: 'มีประสิทธิภาพ',
  expired: 'หมดอายุแล้ว',
  closed: 'ปิด',
  unavailable: 'ไม่สามารถใช้งานได้',
  balance_change_details: 'รายละเอียดการเปลี่ยนแปลงยอดคงเหลือ',
  voucher: 'คูปอง',
  replies: 'ตอบกลับ',
  receipt: 'คูปอง',
  view: 'ดู',
  camera: 'กล้อง',
  album: 'อัลบั้ม',
  processing: ' รอดำเนินการ',
  success: 'สำเร็จ',
  failed: 'ล้มเหลว',
  waiting: 'เดี๋ยว',
  top_up_success: 'เติมเงินสำเร็จ',
  top_up_failed: 'การเติมเงินล้มเหลว',
  top_up_processing: 'การประมวลผลการเติมเงิน',
  cash_out_success: 'ถอนเงินสำเร็จ',
  cash_out_failed: 'การถอนเงินล้มเหลว',
  cash_out_processing: 'การถอนเงินรอดำเนินการ',
  transfer_out_success: 'โอนเงินออกสำเร็จ',
  transfer_out_failed: 'การโอนออกล้มเหลว',
  transfer_out_processing: 'รอการโอนออก',
  mobile_top_up_success: 'เติมเงินมือถือสำเร็จ',
  mobile_top_up_failed: 'การเติมเงินโทรศัพท์ล้มเหลว',
  mobile_top_up_processing: 'การประมวลผลการเติมเงินมือถือ',
  replicating_fail: 'การคัดลอกล้มเหลว',
  replicating_success: 'คัดลอกสำเร็จ',
  submit_successfully: 'ส่งเรียบร้อยแล้ว',
  current_audit_status: 'สถานะการตรวจสอบปัจจุบัน',
  remark: 'หมายเหตุ',
  amount_unpaid: 'จำนวนเงินที่ยังไม่ได้ชำระ',
  amount_paid: 'จำนวนเงินที่ชำระแล้ว',
  id_photos: 'รูปถ่ายบัตรประจำตัว',
  upload_a_photo: 'อัปโหลดภาพเซลฟี่พร้อมบัตรประจำตัว',
  signature: 'ลายเซ็น',
  clear_signature: 'ลบลายเซ็น',
  view_guidelines: 'ดูแนวทาง',
  id_number: 'หมายเลขประจำตัวประชาชน',
  overview: 'ภาพรวม',
  collapse: 'ย่อ',
  expand: 'ขยาย',
  pay: 'ชำระเงิน',
  view_payment_history: 'ดูประวัติการชำระเงิน',
  delivery_bills_amount_due: 'ยอดบิลการจัดส่งที่ค้างชำระ',
  delivery_bills_unpaid_amount: 'จำนวนเงินบิลการจัดส่งที่ยังไม่ชำระ',
  cod_settlement_bills: 'ยอดบิลการชำระเงิน COD',
  delivery_bills_paid_amount: 'จำนวนเงินที่ชำระบิลการจัดส่ง',
  delivery_bills_total_amount: 'ยอดรวมบิลการจัดส่ง',
  cod_settlement_bills_total_amount: 'จำนวนเงินรวมบิลการชำระ COD',
  cod_settlement_bills_paid_amount: 'จำนวนเงินที่ชำระสำหรับบิลการชำระ COD',
  payment_complete: 'ชำระเงินเรียบร้อย',
  checkout_paid_history: 'ตรวจสอบประวัติการชำระเงิน',
  ver_code: 'รหัสยืนยัน',
  please_make_sure_the_information_correct:
    'กรุณาตรวจสอบให้แน่ใจว่าข้อมูลข้างต้นถูกต้อง การทำธุรกรรมที่ส่งแล้วไม่สามารถย้อนกลับได้.',
  dialog_verification_title: 'ต้องการการยืนยัน',
  dialog_verification_content: 'กรุณายืนยันตัวตนของคุณให้เรียบร้อยเพื่อดำเนินการต่อ.',
  dialog_no_my_phone_content: 'กรุณาติดต่อ J&T เพื่ออัปเดตหมายเลขโทรศัพท์มือถือของคุณ.',
  close: 'ปิด',
  i_have_read: 'ฉันได้อ่าน เข้าใจ และยอมรับ',
  privacy_policy: 'นโยบายความเป็นส่วนตัว',
  terms_and_conditions: 'ข้อตกลงและเงื่อนไข',
  the_special_rules_for_user: 'กฎพิเศษสำหรับผู้ใช้ J&T Wallet',
  special_rules: 'กฎพิเศษสำหรับผู้ใช้ฟังก์ชัน J&T Wallet ที่ขับเคลื่อนโดย Bluepay',
  start_verification: 'เริ่มการยืนยัน',
  global_jet_express: 'Global Jet Express',
  and_the_following: 'และบริษัทต่อไปนี้',
  companies: 'บริษัท',
  payments_tips: 'การชำระเงินจะถูกหักโดยอัตโนมัติและคุณจะได้รับการแจ้งเตือนโดยไม่ต้องยืนยันเพิ่มเติม.',
  payments_details_tips:
    'รายละเอียดการชำระเงินจะถูกส่งไปยังกระเป๋าเงิน Bluepay ของคุณ กรุณาตรวจสอบรายการธุรกรรมของคุณสำหรับการอัปเดต.',
  agree_gray: 'โดยการเปิดใช้งานการหักเงินอัตโนมัติ คุณยอมรับ',
  agree_red: 'ข้อตกลงบริการการอนุญาตการชำระเงิน',
  account_settings: 'การตั้งค่าบัญชี',
  auto_debit_activate: 'เปิดใช้งานการหักบัญชีอัตโนมัติ',
  auto_debit: 'การหักบัญชีอัตโนมัติ',
  bluepay_account_id: 'รหัสบัญชีบลูเพย์',
  payment_method: 'วิธีการชำระเงิน',
  termination_completed: 'การยุติเสร็จสมบูรณ์',
  jt_1: 'บริษัท โกลบอล เจท เอ็กซ์เพรส ',
  jt_2: '(ไทยแลนด์) จำกัด',
  payment_details: 'รายละเอียดการชำระเงิน',
  auto_debit_tip_1: 'การชำระเงินจะถูกหักโดยอัตโนมัติ และคุณจะได้รับแจ้งโดยไม่ต้องมีการยืนยันเพิ่มเติม',
  auto_debit_tip_2:
    'ข้อมูลสำหรับการชำระเงินแบบหักบัญชีอัตโนมัติจะถูกแจ้งผ่านกระเป๋าเงิน Bluepay กรุณาตรวจสอบรายการธุรกรรมสำหรับรายละเอียด',
  auto_debit_terminate: 'ยุติการหักบัญชีอัตโนมัติ',
  terminate_auto_debit: 'ยุติการหักบัญชีอัตโนมัติ',
  protocol_1: 'ข้อตกลงบริการการอนุมัติการชำระเงิน',
  protocol_2: 'สำหรับข้อมูลเพิ่มเติมหรือข้อกังวล',
  protocol_3: 'การเปิดใช้งานการหักบัญชีอัตโนมัติ, คุณยอมรับ',
  protocol_4: 'เยี่ยมชม',
  activation_successful: 'การเปิดใช้งานสำเร็จ',
  terminate_tip_1: 'คุณแน่ใจหรือไม่ว่าต้องการยุติการชำระเงินแบบหักบัญชีอัตโนมัติ',
  terminate_tip_2: 'การดำเนินการนี้จะหยุดการชำระเงินแบบหักบัญชีอัตโนมัติทั้งหมดในอนาคตให้กับผู้ประกอบการรายนี้',
  enter_verification_code: 'ป้อนรหัสยืนยัน',
  activation_date_time: 'วันที่และเวลาที่เปิดใช้งาน',
  termination_date_time: 'วันที่เเละเวลาสิ้นสุด',
  merchant: 'ร้านค้า',
  authorization_has_been_completed: 'ทำการอนุมัติเรียบร้อยแล้ว',
  auto_debit_payment_method: 'วิธีการชำระเงินแบบหักบัญชีอัตโนมัติ',
  bill_type: 'ประเภทบิล',
  bill_status: 'สถานะบิล',
  create_date: 'วันที่สร้าง',
  bill_amount: 'ยอดบิล',
  bill_paid_amount: 'จำนวนเงินที่ชำระบิล',
  bill_number: 'หมายเลขบิล',
  merchant_order_id: 'หมายเลขคำสั่งซื้อของผู้ค้า',
  bill_final_payment_date: 'วันที่ชำระเงินสุดท้ายของบิล',
  bill_create_time: 'เวลาสร้างบิล',
  bill_complete_time: 'เวลาที่เสร็จสมบูรณ์ของบิล',
  clear_status: 'สถานะการชำระเงิน',
  clear_amount: 'จำนวนเงินที่ชำระ',
  clear_reference_number: 'หมายเลขอ้างอิงการชำระเงิน',
  related_transaction_id: 'หมายเลขธุรกรรมที่เกี่ยวข้อง',
  related_wallet_transaction_id: 'หมายเลขธุรกรรมกระเป๋าเงินที่เกี่ยวข้อง',
  clear_type: 'ประเภทการชำระเงิน',
  clear_create_time: 'เวลาสร้างการชำระเงิน',
  clear_complete_time: 'เวลาที่เสร็จสมบูรณ์ของการชำระเงิน',
  merchant_name: 'ชื่อผู้ค้า',
  transfer_amount: 'จำนวนเงินที่ต้องการโอน',
  receiver_account: 'เลขบัญชีผู้รับเงิน',
  receiver_account_name: 'ชื่อบัญชีผู้รับเงิน',
  transfer_out_fee: 'ค่าธรรมเนียมการโอนออก',
  upload_id: 'อัปโหลดรูปถ่ายบัตรประชาชน',
  face_recognition: 'การจดจำใบหน้า',
  dyna_face_scan_ready_title: 'เตรียมพร้อมสแกนใบหน้าของคุณ',
  dyna_face_scan_tips_title: 'คำแนะนำการสแกนใบหน้า',
  dyna_face_scan_tip_1: 'โปรดอยู่ในบริเวณที่มีแสงสว่างเพียงพอ',
  dyna_face_scan_tip_2: 'จัดใบหน้าของคุณให้อยู่ภายในกรอบ',
  dyna_face_scan_tip_3: 'โปรดรอสักครู่เพื่อให้ระบบสแกนอัตโนมัติ',
  dyna_face_scan_tip_4: 'กรุณาอย่าสวมหน้ากากขณะสแกน',
  dyna_face_scan_tip_5: 'ลืมตาและมองไปที่กล้อง',
  dyna_face_scan_cta: 'ไปสแกนใบหน้า',
  dyna_face_scan_illustration_alt: 'ภาพตัวอย่างคำแนะนำการสแกนใบหน้า',
  dyna_face_scan_config_missing: 'ยังไม่ได้ตั้งค่า LiveWeb face scan กรุณากำหนด account_id และ app_key ก่อน',
  dyna_face_scan_image_fetch_failed: 'ไม่สามารถดึงภาพใบหน้าที่ดีที่สุดได้ กรุณาสแกนใหม่อีกครั้ง',
  dyna_face_scan_image_timeout: 'การดึงภาพใบหน้าที่ดีที่สุดหมดเวลา กรุณาสแกนใหม่อีกครั้ง',
  dyna_face_scan_image_not_found: 'ไม่พบผลลัพธ์ภาพใบหน้าที่ตรงกับคำขอนี้',
  dyna_face_scan_image_cache_expired: 'แคชภาพใบหน้าหมดอายุแล้ว กรุณาเริ่มสแกนใหม่',
  dyna_face_scan_image_auth_failed: 'การยืนยันตัวตนของ LiveWeb image ล้มเหลว กรุณาตรวจสอบ account_id และ app_key',
  open_camera: 'เปิดกล้องถ่ายรูปของคุณ',
  face_tips: 'กรุณาใช้กล้องถ่ายรูปของคุณเพื่อดำเนินการต่อ',
  confirm_information: 'ยืนยันข้อมูล',
  id_card_information: 'ยืนยันบัตรประชาชน',
  en_first_name: 'ชื่อจริงภาษาอังกฤษ',
  full_name: 'ชื่อ-สกุล',
  en_last_name: 'นามสกุลภาษาอังกฤษ',
  laser_number: 'หมายเลขหลังบัตร',
  date_of_issue: 'วันที่ออกบัตร',
  date_of_Expire: 'วันที่หมดอายุ',
  additional_information: 'ข้อมูลเพิ่มเติม',
  monthly_income: 'รายได้ต่อเดือน',
  email: 'อีเมล',
  Verifying_your_identity: 'กำลังยืนยันตัวตนของคุณ',
  This_may_take_a_few_seconds: 'อาจใช้เวลาสักครู่ กรุณาอย่าปิดแอป',
  Facial_Recognition_Failed: 'การสแกนใบหน้าไม่สำเร็จ',
  Make_sure_your_face_is_centered: 'ตรวจสอบให้แน่ใจว่าใบหน้าของคุณอยู่ตรงกลางและมีแสงสว่างเพียงพอ จากนั้นลองอีกครั้ง',
  Try_Again: 'ลองอีกครั้ง',
  Return: 'ย้อนกลับ',
  register_address: 'ที่อยู่ตามทะเบียนบ้าน',
  Country: 'ประเทศ',
  Sex: 'เพศ',
  Issuing_State: 'สถานที่ออกเอกสาร',
  MALE: 'ชาย',
  FEMALE: 'หญิง',
  Current_Address: 'ที่อยู่ปัจจุบัน',
  Street_Address: 'ที่อยู่',
  Address_Details: 'รายละเอียดที่อยู่',
  Work_Location: 'ที่ตั้งบริษัท',
  Work_Street_Address: 'ที่อยู่บริษัท',
  Occupation: 'อาชีพ',
  Wallet_Usage_Purpose: 'จุดประสงค์การใช้ Wallet',
  Upload_Selfie_with_ID: 'อัปโหลดรูปถ่ายตัวเองพร้อมบัตรประชาชน',
  dyna_upload_id_subtitle: 'โปรดตรวจสอบให้แน่ใจว่ามีแสงสว่างเพียงพอและเห็นเอกสารระบุตัวตนของคุณอย่างชัดเจน',
  dyna_upload_id_front_side: 'ด้านหน้าของเอกสาร',
  dyna_upload_id_back_side: 'ด้านหลังของเอกสาร',
  dyna_upload_passport_page: 'หน้าข้อมูลหนังสือเดินทาง',
  dyna_upload_id_privacy_notice: 'เราจะปกป้องข้อมูลส่วนบุคคลของคุณตามกฎหมายไทย',
  Daily_Expenses_Payments: 'ค่าใช้จ่ายประจำวัน',
  Money_Transfer: 'การโอนเงิน',
  Bill_payment: 'การชำระเงิน',
  Investment_Savings: 'การลงทุน/การออม',
  Donations_Charity: 'การบริจาค/การกุศล',
  Online_Shopping_E_Commerce: 'ซื้อ-ขายออนไลน์',
  Business_Merchant_Services: 'บริการสำหรับร้านค้าและธุรกิจ',
  Clear_Signature: 'ล้างลายเซ็น',
  ID_Front: 'หน้าบัตรประชาชน',
  ID_Back: 'หลังบัตรประชาชน',
  Selfie_with_ID: 'รูปตนเองกับบัตรประชาชน',
  Please_enter_the_correct_email_address: 'โปรดกรอกอีเมลให้ถูกต้อง',
  Please_enter_the_correct_identification: 'กรุณากรอกหมายเลขเอกสารให้ถูกต้อง',
  Please_enter_the_correct_Laser_ID: 'กรุณาป้อนรหัสเลเซอร์ที่ถูกต้อง',
  Purpose_Description: 'รายละเอียดวัตถุประสงค์',
  Please_enter_the_correct_information_required_address: 'เลขที่, หมู่, ซอย, ถนน, รหัสไปรษณีย์',
  Please_enter_the_correct_information_required: 'กรุณาป้อนข้อมูลที่ถูกต้องตามความต้องการ',
  confirm_submit:
    'ยืนยันการส่งข้อมูล ข้อมูลของคุณกำลังอยู่ในระหว่างการตรวจสอบ เวลาทำการของเราคือ 08:00 น. ถึง 22:00 น. และข้อมูลของคุณจะได้รับการดำเนินการภายใน 1 ชั่วโมงในช่วงเวลาดังกล่าว หากต้องการความช่วยเหลือ กรุณาติดต่อฝ่ายบริการลูกค้าของเราทางอีเมล: onboard@bluepay.asia',
  permission_request_title: 'ขอสิทธิ์การเข้าถึง',
  Please_agree_to_the_camera_permission: 'โปรดยอมรับสิทธิ์ของกล้องก่อน',
  camera_permission_required_for_verification:
    'เพื่อดำเนินการยืนยันตัวตนในขั้นตอนนี้ ระบบจำเป็นต้องขอสิทธิ์เข้าถึงกล้องของคุณ เพื่อใช้สำหรับการสแกนใบหน้าหรือถ่ายภาพเอกสารสำหรับการตรวจสอบด้วย OCR หากคุณไม่อนุญาตการเข้าถึงกล้อง ระบบจะไม่สามารถเก็บข้อมูลที่จำเป็นสำหรับการยืนยันตัวตนได้ และคุณจะไม่สามารถดำเนินการไปยังขั้นตอนถัดไปได้',
  how_to_take_a_selfie_with_your_id: 'วิธีถ่ายรูปตนเองพร้อมกับบัตรประชาชนของคุณ',
  how_to_take_a_selfie_tips_1: '1. ถือบัตรประจำตัวที่ถูกต้องของคุณไว้ข้างหน้า',
  how_to_take_a_selfie_tips_2: '2. โปรดให้เห็นใบหน้าและบัตรประจำตัวประชาชนของคุณอย่างชัดเจน',
  how_to_take_a_selfie_tips_3: '3. อยู่ในพื้นที่ที่มีแสงสว่างเพียงพอและมีฉากหลังที่เรียบง่าย',
  how_to_take_a_selfie_tips_4: '4. ถอดหน้ากาก หมวก หรือแว่นกันแดดออก',
  how_to_take_a_selfie_tips_5: '5. โปรดตรวจสอบให้แน่ใจว่ารายละเอียดบนบัตรประจำตัวไม่เบลอหรือถูกปิดบัง',
  got_it: 'รับทราบแล้ว',
  account_activated: 'บัญชีเปิดใช้งานแล้ว!',
  account_activated_content:
    'สำเร็จ! ข้อมูลส่วนตัวของคุณได้รับการยืนยันเรียบร้อยแล้ว ตอนนี้คุณสามารถเติมเงิน ถอนเงิน และโอนเงินโดยใช้บัญชีของคุณได้',
  I_agree_to_the: 'ฉันตกลงตาม...',
  kyc_service_agreement_certification: 'นโยบายความเป็นส่วนตัวสำหรับกระบวนการรู้จักลูกค้า (KYC)',
  Upload_proof_of_employment: 'อัปโหลดเอกสารยืนยันการทำงาน',
  Top_Up_Toast: 'ขณะนี้เรากำลังตรวจสอบข้อมูลของคุณ คุณจะสามารถทำรายการเติมเงินได้เมื่อการตรวจสอบได้รับการอนุมัติแล้ว',
  Cash_Out_Toast: 'ขณะนี้เรากำลังตรวจสอบข้อมูลของคุณคุณจะสามารถถอนเงินสดได้เมื่อการตรวจสอบได้รับการอนุมัติแล้ว',
  Transfer_Toast: 'ขณะนี้เรากำลังตรวจสอบข้อมูลของคุณคุณจะสามารถโอนเงินได้เมื่อการตรวจสอบได้รับการอนุมัติแล้ว',
  mobile_top_up_Toast:
    'ขณะนี้เรากำลังตรวจสอบข้อมูลของคุณ เมื่อการตรวจสอบได้รับการอนุมัติ คุณจะสามารถเติมเงินมือถือได้ทันที',
  job_title: 'ตำแหน่งงาน',
  Official_Workplace: 'สถานที่ทำงาน',
  Failure_Reason: 'สาเหตุที่ล้มเหลว',
  Foreigner: 'ชาวต่างชาติ',
  Thailand: 'ประเทศไทย',
  face_title_text: 'กรุณาใช้ประเภทบัตรประจำตัวที่ถูกต้อง',
  face_tip_text:
    'ผู้มีสัญชาติไทยสามารถใช้ได้เฉพาะบัตรประชาชนสำหรับการยืนยันตัวตน กรุณาอัปโหลดบัตรที่ถูกต้องและลองใหม่อีกครั้ง',
  fee_waived: 'ยกเว้นค่าธรรมเนียมโดย J&T',
  expected_deposit_time: 'เวลาที่คาดว่าจะได้รับเงินฝาก',
  two_work_hours: '2 ชั่วโมงภายในเวลาทำการ',
  failure_reason: 'สาเหตุที่ล้มเหลว',
  proof_of_transfer: 'หลักฐานการโอนเงิน',
  per_top_up_limit: 'วงเงินเติมเงินต่อรายการ',
  daily_remaining: 'วงเงินคงเหลือรายวัน',
  monthly_remaining: 'วงเงินคงเหลือรายเดือน',
  issue_date_later_than_expiration_date: 'วันหมดอายุของเอกสารจะต้องอยู่หลังจากวันที่ออกเอกสาร',
  // MapString
  top_up_method_1: 'โอนเงินผ่านธนาคาร',
  top_up_method_2: 'ชำระเงินผ่าน QR Code',
  transaction_type_1: 'เติมเงิน',
  transaction_type_2: 'เติมเงินโทรศัพท์มือถือ',
  transaction_type_3: 'ถอนเงินสด',
  transaction_type_4: 'การเติมเงินโทรศัพท์ไม่สำเร็จ',
  transaction_type_5: 'การถอนเงินไม่สำเร็จ',
  transaction_type_6: 'เงินเข้า',
  transaction_type_7: 'หักบัญชีอัตโนมัติ',
  transaction_type_8: 'โอนออก',
  transaction_type_11: 'การโอนออกล้มเหลว',
  transaction_status_1: ' รอดำเนินการ',
  transaction_status_2: 'สำเร็จ',
  transaction_status_3: 'ล้มเหลว',
  identity_audit_status_1: ' รอดำเนินการ',
  identity_audit_status_2: 'ตรวจสอบแล้ว',
  identity_audit_status_3: 'ยกเลิก',
  feedback_type_1: 'ปัญหาการเติมเงินในแอปพลิเคชั่น',
  feedback_type_2: 'ปัญหาการเติมเงินโทรศัพท์มือถือ',
  feedback_type_3: 'ปัญหาการถอนเงิน',
  feedback_type_4: 'ปัญหาการเข้าสู่ระบบ',
  feedback_type_5: 'ปัญหารหัสผ่าน',
  feedback_type_6: 'การส่งคำถามเกี่ยวกับข้อมูลส่วนบุคคล',
  feedback_type_7: 'ปัญหาการหักบัญชีอัตโนมัติ',
  feedback_type_8: 'ปัญหาการเติมเงินเข้าสู่บัญชี',
  feedback_type_9: 'เพิ่มปัญหาเกี่ยวกับบัตรธนาคาร',
  feedback_type_10: 'ปัญหาการโอนออก',
  feedback_type_11: 'ปัญหาการปิดใช้งานบัญชี',
  feedback_type_12: 'ปัญหาอื่นๆ',
  feedback_type_16: 'ปปัญหาการล็อกรหัส PIN สำหรับการชำระเงิน',
  payment_method_1: 'ยอดเงิน', // ยอดเงินคงเหลือ
  auto_debit_status_1: 'เปิดใช้งาน',
  auto_debit_status_2: 'สิ้นสุด',
  notify_type_1: 'เปิดใช้งานการหักบัญชีอัตโนมัติ',
  notify_type_2: 'ยุติการหักบัญชีอัตโนมัติ',
  notify_type_3: 'การชำระเงินอัตโนมัติที่สำเร็จ',
  notify_type_4: 'ข้อเสนอแนะและการตอบกลับการร้องเรียน',
  bills_status_1: ' รอดำเนินการ',
  bills_status_2: 'กำลังดำเนินการ',
  bills_status_3: 'เสร็จสมบูรณ์',
  bills_status_4: 'รอยกเลิก',
  bills_status_5: ' ยกเลิกแล้ว',
  bills_type_1: 'บิลการชำระเงิน COD',
  bills_type_2: 'บิลการจัดส่ง',
  consumption_type_1: 'การชำระเงิน',
  limit_level_type_1: 'วงเงินจำกัดของกระเป๋าเงิน',
  limit_level_type_2: 'วงเงินจำกัดของการเติมเงินรายวัน',
  limit_level_type_3: 'วงเงินจำกัดของการเติมเงินรายเดือน',
  limit_level_type_4: 'วงเงินจำกัดการทำธุรกรรมใช้จ่ายรายวัน',
  limit_level_type_5: 'วงเงินจำกัดการทำธุรกรรมใช้จ่ายรายเดือน',
  limit_level_type_6: 'วงเงินโอนออกและถอนเงินรายวัน',
  limit_level_type_7: 'วงเงินโอนออกและถอนเงินรายเดือน',
  limit_level_type_8: 'วงเงินโอนเข้ารายวัน',
  limit_level_type_9: 'วงเงินโอนเข้ารายเดือน',
  limit_level_content_1: 'จำนวนเงินสูงสุดที่สามารถเก็บไว้ใน Bluepay Wallet ของคุณได้',
  limit_level_content_2: 'จำนวนเงินสูงสุดที่สามารถเติมเงินใน Bluepay Wallet ของคุณต่อวัน',
  limit_level_content_3: 'จำนวนเงินสูงสุดที่สามารถเติมเงินใน Bluepay Wallet ของคุณต่อเดือน',
  limit_level_content_4: 'ยอดเงินสูงสุดที่สามารถสะสมใช้เพื่อชำระเงินผ่าน BluePay Wallet ต่อวัน',
  limit_level_content_5: 'ยอดเงินสูงสุดที่สามารถสะสมใช้เพื่อชำระเงินผ่าน BluePay Wallet ต่อเดือน',
  limit_level_content_6: 'จำนวนเงินสูงสุดที่สามารถโอนออกหรือถอนออกจาก BluePay Wallet ได้ต่อวัน',
  limit_level_content_7: 'จำนวนเงินสูงสุดที่สามารถโอนออกหรือถอนออกจาก BluePay Wallet ได้ต่อเดือน',
  limit_level_content_8: 'จำนวนเงินสูงสุดที่สามารถโอนเข้า BluePay Wallet ได้ต่อวัน',
  limit_level_content_9: 'จำนวนเงินสูงสุดที่สามารถโอนเข้า BluePay Wallet ได้ต่อเดือน',
  // SentenceString
  agree_policy: 'I have agreed to the privacy agreement and service policy',
  enter_phone_number: '+66  กรุณากรอกหมายเลขโทรศัพท์ของคุณ',
  phone_is_required: 'Phone number is required',
  enter_password: 'ใส่รหัสผ่าน',
  enter_new_password: 'ใส่รหัสผ่านใหม่',
  confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
  question_tip: 'มีข้อสงสัยเกี่ยวกับคำสั่งซื้อนี้?',
  question_tip_2: 'เพิ่มบัตรของคุณไม่ได้ใช่ไหมคะ?',
  login_with_password: 'เข้าสู่ระบบด้วยรหัสผ่าน',
  login_with_code: 'เข้าสู่ระบบด้วยรหัสยืนยัน',
  change_login_password: 'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
  service_and_help: 'ศูนย์ช่วยเหลือและบริการลูกค้า',
  tip_transfer_corresponding_amount_account: 'คุณต้องโอนเงินเข้าบัญชีนี้:',
  tip_upload_proof_transfer: 'กรุณาอัพโหลดหลักฐานการโอนเงิน:',
  confirm_submit_transaction_tip:
    'โปรดตรวจสอบว่าข้อมูลข้างต้นถูกต้องและถูกต้อง ประวัติการทำธุรกรรมที่ยื่นไปแล้วไม่สามารถหักล้างได้',
  this_field_is_required: 'กรุณากรอกรูปแบบชื่อที่ถูกต้อง',
  please_enter_the_correct_name_format: 'ฟิลด์นี้จำเป็น',
  password_inconsistency: 'การป้อนรหัสผ่านสองครั้งไม่สอดคล้องกัน',
  select_top_up_method: 'เลือกวิธีการเติมเงิน',
  receiving_bank_account: 'บัญชีธนาคารผู้รับเงิน',
  enter_amount: 'ใส่จำนวนเงิน',
  please_enter_9_digits: 'กรุณาใส่ตัวอักษรและตัวเลข 9 หลัก',
  please_enter_12_digits_or_letter: 'กรุณาใส่ตัวอักษรและตัวเลข 12 หลัก',
  please_enter_13_digits: 'กรุณากรอก 13 หลัก',
  please_enter_least_6_digits_or_letter: 'กรุณากรอกตัวเลขหรือตัวอักษร 6 ถึง 9 หลัก',
  laser_id_valid_tips: 'ใส่ได้เฉพาะตัวอักษรตัวเลข และ ,- ,ไม่เกิน 20 หลัก',
  upload_front_photo_id: 'อัปโหลดรูปถ่ายด้านหน้าบัตรประจำตัวของคุณ',
  q_1: 'วิธีการเข้าสู่ระบบแอป Bluepay?',
  a_1: 'ในการเข้าสู่ระบบแอป Bluepay โปรดทำตามขั้นตอนต่อไปนี้:ดาวน์โหลดและติดตั้งแอปบนอุปกรณ์มือถือของคุณเปิดแอปและเลือกตัวเลือก "เข้าสู่ระบบ" ในหน้าการลงทะเบียน.ป้อนหมายเลขโทรศัพท์ที่คุณลงทะเบียนและรหัสผ่านที่เกี่ยวข้องคลิกที่ปุ่ม "เข้าสู่ระบบ" เพื่อดำเนินการเข้าสู่ระบบให้เสร็จสมบูรณ์',
  q_2: 'ฉันจะเติมเงินในแอปได้อย่างไร?',
  a_2: 'การเติมเงินในแอปพลิเคชัน สามารถทำได้ตามขั้นตอนดังนี้ ในหน้าหลักของแอป ไปที่ "เติมเงิน" และแตะเพื่อเข้าสู่เนื้อหา เลือกวิธีการเติมเงิน เช่น บัตรเอทีเอ็ม เป็นต้น ใส่จำนวนเงินที่เติมเงิน และยืนยันข้อมูลที่เกี่ยวข้อง ดำเนินการตามขั้นตอนการชำระเงินตามวิธีชำระเงินที่เลือก เมื่อชำระเงินเรียบร้อยแล้ว ระบบจะอัปเดตยอดที่เติมเงินเข้าไปโดยอัตโนมัติ',
  q_3: 'ฉันจะถอนเงินออกจากแอปได้อย่างไร?',
  a_3: '"บนหน้าหลักของแอปพลิเคชัน ให้ค้นหาปุ่ม ""ถอนเงิน"" แล้วแตะเพื่อเข้าสู่หน้าถอนเงิน กรอกจำนวนเงินที่ต้องการถอนและยืนยันข้อมูลที่เกี่ยวข้อง เลือกวิธีการถอนเงิน (มักจะมีตัวเลือกเช่น บัญชีธนาคาร เป็นต้น) ส่งคำขอถอนเงินและรอการดำเนินการ เมื่อคำขอถอนเงินได้รับการอนุมัติ จำนวนเงินที่ถอนจะถูกโอนเข้ายังบัญชีการถอนที่คุณเลือก"',
  q_4: 'ฉันจะเติมเงินแอปด้วยโทรศัพท์ของฉันได้อย่างไร',
  a_4: 'ฉันจะเติมเงินแอปด้วยโทรศัพท์ของฉันได้อย่างไร การเติมเงินมือถือผ่านแอพพลิเคชั่น สามารถทำได้ตามขั้นตอนดังนี้ในอินเตอร์เฟซหลักของแอพค้นหา "เติมเงินโทรศัพท์" และแตะเพื่อเข้าสู่หน้าใส่หมายเลขโทรศัพท์และจำนวนเงินที่เติมเงินโทรศัพท์มือถือเลือกวิธีการชำระเงินและทำตามขั้นตอนการชำระเงิน (เช่นยอดคงเหลือ ฯลฯ )เมื่อเติมเงินมือถือสำเร็จ ยอดคงเหลือในโทรศัพท์ของคุณจะเพิ่มขึ้นโดยอัตโนมัติ',
  upload_back_photo_id: 'อัปโหลดรูปถ่ายด้านหลังบัตรประจำตัวของคุณ',
  handheld_id_photo: 'อัปโหลดรูปถ่ายเซลฟี่พร้อมบัตรประจำตัวของคุณ',
  uploading_with_dot: 'กำลังอัปโหลด...',
  loading_with_dot: 'กำลังโหลด...',
  view_history: 'ดูประวัติ',
  enter_personal_info_bank_info: 'กรุณากรอกข้อมูลบัตรประชาชนและบัญชีธนาคาร',
  feedback_sent_success: 'ส่งข้อเสนอแนะเรียบร้อยแล้ว',
  please_enter: 'กรุณากรอก',
  please_sselect_your_region: 'กรุณาเลือกภูมิภาค',
  pls_enter_10_num: 'กรุณากรอกตัวเลข 10 หลัก',
  input_value_cannot_spaces: 'าอินพุตต้องไม่มีช่องว่าง',
  please_enter_two_decimal: 'โปรดป้อนจำนวนที่ไม่เป็นลบ พร้อมทั้งมีตำแหน่งทศนิยมไม่เกิน 2 ตำแหน่ง',
  please_enter_non_negative_number: 'กรุณาใส่ตัวเลขที่ไม่ติดลบ',
  please_sign_by_hand: 'ลงชื่อด้วยลายมือ',
  please_enter_non_zero_number: 'โปรดป้อนจำนวนเต็มที่ไม่ใช่ศูนย์',
  please_enter_two_decimal_places: 'กรุณาใส่ทศนิยมสองตำแหน่ง',
  please_enter_9_19_digits: 'กรุณากรอกตัวเลข 9 ถึง 19 หลัก',
  please_check_info_correct: 'กรุณาตรวจสอบว่ากรอกข้อมูลถูกต้องหรือไม่',
  there_are_unfilled_fields: 'มีช่องที่ยังไม่ได้กรอก',
  valid_password_tips: '8-15 ตัวอักษร โดยใช้ตัวอักษร ตัวเลข และสัญลักษณ์ผสมกัน',
  please_enter_0_or_9_digits_phone_number: ' กรุณาใส่ 0 + 9 หลัก / หมายเลขโทรศัพท์ 9 หลัก',
  // 'privacy_sentence1': 'บริษัท บลูเพย์ จำกัด (ต่อไปนี้จะเรียกว่า "บริษัท") ตระหนักถึงความสำคัญของความเป็นส่วนตัวและการปกป้องข้อมูลส่วนบุคคลสำหรับลูกค้าและลูกค้าของบริษัท (รวมเรียกว่า "คุณ") บริษัทฯ จึงได้กำหนดนโยบายคุ้มครองข้อมูลส่วนบุคคล และแจ้งให้ท่านทราบถึงแนวทางที่บริษัทฯ รวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล เพื่อให้ท่านสามารถใช้บริการ e-Money ได้อย่างมั่นใจผ่านแอปพลิเคชัน BluePay ("Application") บริการชำระเงิน บริการโอนเงินทางอิเล็กทรอนิกส์ และบริการอื่นๆ ที่ธนาคารแห่งประเทศไทยอนุมัติ บริการที่มีอยู่ในปัจจุบันและอาจมีอยู่ในอนาคต รวมถึงแต่ไม่จำกัดเฉพาะบริการใด ๆ ที่เกี่ยวข้องกับการใช้แอปพลิเคชัน เว็บไซต์ และช่องทางอื่น ๆ ที่บริษัทจัดหาให้ (รวมเรียกว่า "บริการ")',
  // 'privacy_title1': 'ข้อมูลส่วนตัว',
  // 'privacy_sentence2': '"ข้อมูลส่วนบุคคล" หมายถึง ข้อมูลที่เกี่ยวข้องกับบุคคลซึ่งสามารถระบุตัวบุคคลได้ทั้งทางตรงและทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้เสียชีวิต เช่น ชื่อ เลขบัตรประชาชน ที่อยู่ หมายเลขโทรศัพท์ ธุรกรรมทางการเงิน',
  // 'privacy_sentence3': 'ข้อมูลส่วนบุคคลอาจประกอบด้วยข้อมูลที่ละเอียดอ่อนและมีความเสี่ยงที่จะได้รับการปฏิบัติอย่างไม่เป็นธรรม (ข้อมูลส่วนบุคคลที่ละเอียดอ่อน) ข้อมูลส่วนบุคคลดังกล่าวรวมถึงแต่ไม่ จำกัด เพียงข้อมูลไบโอเมตริกซ์ข้อมูลที่เกี่ยวข้องกับศาสนา',
  // 'privacy_sentence4': 'ในการนี้ข้อมูลส่วนบุคคลดังกล่าวรวมถึงข้อมูลใด ๆ ที่คุณให้กับ บริษัท และ / หรือที่ บริษัท เป็นเจ้าของและ / หรือที่ บริษัท เก็บรวบรวมอย่างถูกต้องตามกฎหมายจากแหล่งอื่น ๆ หรือบุคคลอื่น',
  // 'privacy_sentence5': 'หาก บริษัท จำเป็นต้องเก็บรวบรวมใช้หรือเปิดเผยข้อมูลส่วนบุคคลที่อยู่นอกเหนือขอบเขตที่กำหนดไว้ในนโยบายความเป็นส่วนตัวนี้ บริษัท จะแจ้งให้คุณทราบถึงคุณลักษณะที่แตกต่างกันเหล่านี้เมื่อหรือก่อนการรวบรวมใช้และเปิดเผยข้อมูลส่วนบุคคลของคุณ',
  // 'privacy_sentence6': 'เมื่อใช้บริการนี้ถือว่าคุณได้อ่านและเข้าใจนโยบายความเป็นส่วนตัวนี้แล้ว ไม่เช่นนั้นให้หยุดใช้บริการทันที',
  // 'privacy_title2': 'ประเภทของข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม ใช้ หรือเปิดเผย',
  // 'privacy_sentence7': 'ข้อมูลเกี่ยวกับบัตรประชาชน หนังสือเดินทาง และ/หรือหลักฐานอื่นที่ออกโดยหน่วยงานของรัฐ เช่น หมายเลขบัตรประชาชน ชื่อ นามสกุล คำนำหน้าชื่อ ลายเซ็น',
  // 'privacy_sentence8': 'ข้อมูลการติดต่อที่จำเป็น เช่น ที่อยู่ติดต่อ หมายเลขโทรศัพท์',
  // 'privacy_sentence9': 'ลักษณะส่วนบุคคลพิเศษเช่นอัตลักษณ์ข้อมูลไบโอเมตริกซ์ภาพถ่าย',
  // 'privacy_sentence10': 'ข้อมูลการศึกษาและ/หรืออาชีพ',
  // 'privacy_sentence11': 'ข้อมูลทางการเงิน เช่น บันทึกการทำธุรกรรมผ่านบัญชี BluePay หรือบริการอื่นๆ ข้อมูลบัตรเครดิต ข้อมูลบัญชีเงินฝาก',
  // 'privacy_sentence12': 'ข้อมูลที่เกี่ยวข้องกับอุปกรณ์ระบบและพฤติกรรมการใช้งานของคุณรวมถึงแต่ไม่ จำกัด เพียงหมายเลขประจำตัวอุปกรณ์ที่เกี่ยวข้องกับการเชื่อมต่อเครือข่าย (เช่น IP Address, MAC Address, ID อุปกรณ์), ID โฆษณา, ระบบปฏิบัติการของอุปกรณ์มือถือ, ผู้ให้บริการเครือข่ายมือถือ, ที่ตั้ง, รายละเอียดการใช้งานอุปกรณ์, คุกกี้, สมุดโทรศัพท์, การใช้งานแอพพลิเคชัน, ข้อมูลทางเทคนิค รุ่นและประเภทของอุปกรณ์, ภาพถ่าย, ภาพและอัลบั้ม.',
  // 'privacy_sentence13': 'หากจำเป็นต้องให้บริการอื่น ๆ นอกเหนือจากบริการพื้นฐานหรือการเก็บรวบรวมการใช้การเปิดเผยข้อมูลส่วนบุคคลที่ละเอียดอ่อนนอกเหนือจากที่ระบุไว้ข้างต้น บริษัท จะดำเนินการตามพื้นฐานทางกฎหมายที่กำหนดไว้ในกฎหมายเท่านั้น ในการนี้ บริษัทจะแจ้งวัตถุประสงค์และประเภทของข้อมูลส่วนบุคคลที่จำเป็นต้องรวบรวม ใช้ หรือเปิดเผยก่อนหรือขณะประมวลผล',
  // 'privacy_title3': 'พื้นฐานของการเก็บรวบรวมใช้และเปิดเผยข้อมูลส่วนบุคคลของคุณและวัตถุประสงค์ของการประมวลผลดังกล่าว',
  // 'privacy_sentence14': 'บริษัทจะรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณตามพื้นฐานทางกฎหมายและเพื่อวัตถุประสงค์ดังต่อไปนี้:',
  please_enter_less_amout_than_balance: 'กรุณาใส่จำนวนเงินที่น้อยกว่ายอดคงเหลือที่มีอยู่',
  please_enter_less_amout_than_withdraw_balance: 'กรุณาใส่จำนวนเงินน้อยกว่าบัญชีที่สามารถถอนออกได้',
  please_enter_less_amount_than_transferable_balance: 'กรุณากรอกจำนวนเงินที่ไม่เกินยอดเงินที่สามารถโอนได้',
  submit_bank_info_tips: 'คุณแน่ใจหรือว่าข้อมูลบัตรธนาคารของคุณถูกต้อง?',
  delete_bank_info_tips: 'คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งานบัญชีนี้?',
  insufficient_balance: 'ยอดคงเหลือไม่เพียงพอ?',
  reserve_balance_note: 'หมายเหตุยอดคงเหลือสำรอง:',
  overview_help: 'ความช่วยเหลือภาพรวม',
  delivery_bills_unpaid_amount_tips: '- หมายถึงยอดรวมที่ยังไม่ได้ชำระของบิลการจัดส่ง.',
  delivery_bills_amount_due_tips: '- หมายถึงยอดรวมของบิลการจัดส่งที่คุณต้องชำระในตอนนี้.',
  cod_settlement_bills_tips: '- หมายถึงการชำระเงินปลายทาง (COD) ที่ J&T รวบรวมจากลูกค้าในนามของคุณและชำระให้กับคุณ.',
  delivery_bills_paid_amount_tips: '- หมายถึงยอดรวมของบิลการจัดส่งที่คุณได้ชำระแล้ว.',
  delivery_bills_total_amount_tips: '- หมายถึงยอดรวมของบิลการจัดส่งที่ออก.',
  the_fund_reserve_for_paying_delivery_bills:
    'ยอดเงินดังกล่าวคือค่าใช้จ่ายรวมของบิลค่าจัดส่งที่ต้องชำระ เป็นเงินที่กันไว้สำหรับชำระค่าจัดส่งเท่านั้น ไม่สามารถถอนเงินออกได้ หากมีข้อสงสัยประการใด กรุณาติดต่อ J&T',
  the_fund_frozen_for_paying_delivery_bills:
    'ยอดเงินดังกล่าวคือค่าใช้จ่ายรวมของบิลค่าจัดส่งที่ต้องชำระ เป็นเงินที่กันไว้สำหรับชำระค่าจัดส่งเท่านั้น ไม่สามารถถอนออกเป็นเงินสดได้ หากมีข้อสงสัยประการใด กรุณาติดต่อ J&T',
  valid_bank_phone: 'ต้องมีมากกว่า 6 หลัก',
  topup_mobile_tips: 'จำนวนการซื้อขายของคุณเกินวงเงินที่กำหนด โปรดให้ข้อมูลส่วนบุคคลของคุณสำหรับการทำธุรกรรมเพิ่มเติม',
  services: 'ผู้ให้บริการ',
  pay_in_qr_tips:
    'ถ่ายภาพหน้าจอ (แนะนำ) / ดาวน์โหลดรหัส QR จากนั้นใช้แอปพลิเคชันใดแอปพลิเคชันหนึ่งต่อไปนี้เพื่อดำเนินการชำระเงิน',
  qr_screen_or_download:
    'กรุณาถ่ายภาพหน้าจอหรือคัดลอกลิงก์ดาวน์โหลดเพื่อนำไปเปิดในเบราว์เซอร์ บันทึกคิวอาร์โค้ด และใช้แอปชำระเงินที่รองรับเพื่อสแกนและทำการชำระเงินให้เสร็จสิ้น',
  copy_download_link: 'คัดลอกลิงก์ดาวน์โหลด',

  pay_in_qr_tips_jt: 'ถ่ายภาพหน้าจอ/ดาวน์โหลด QR โค้ด แล้วดำเนินการชำระเงินโดยใช้แอปที่เกี่ยวข้อง.',
  screen_qr_jt: 'กรุณาถ่ายภาพหน้าจอรหัส QR และสแกนด้วยแอปชำระเงินที่รองรับเพื่อดำเนินการชำระเงินของคุณให้เสร็จสิ้น',
  you_have: 'คุณมี ',
  unread_messages: 'ข้อความที่ยังไม่ได้อ่าน ',
  are_you_sure_to_submit: 'คุณแน่ใจนะว่าต้องการส่ง?',
  up_to_5_images_can_be_uploaded: 'อัพโหลดรูปภาพได้สูงสุด 5 ภาพ',
  wallet_balance_limit: 'วงเงินจำกัดในกระเป๋าเงิน',
  wallet_balance_limit_content:
    'ยอดเงินรวมที่สามารถเพิ่มในได้ในกระเป๋าเงินของคุณได้ในแต่ละวัน รวมทั้งการเติมเงินและการโอนเข้า',
  unauthorized: 'ไม่ได้รับอนุญาต',
  basic_account: 'บัญชีพื้นฐาน',
  semi_verified: 'ตรวจสอบแล้วบางส่วน',
  fully_verified: 'ตรวจสอบสมบูรณ์',
  view_benefits: 'ดูสิทธิประโยชน์',
  verify_account: 'ยืนยันบัญชี',
  why_we_require_verification: 'เหตุใดเราจึงต้องการการยืนยัน',
  verification_reason:
    'เพื่อให้เป็นไปตามข้อกำหนดของธนาคารแห่งประเทศไทยและปกป้องเงินของคุณ BluePay จึงใช้ระดับการยืนยันบัญชีที่มีขีดจำกัดการทำธุรกรรมที่เฉพาะเจาะจง',
  verification_reason_jt:
    'เพื่อให้เป็นไปตามข้อกำหนดของธนาคารแห่งประเทศไทยและปกป้องเงินของคุณ J&T Wallet ใช้ระบบยืนยันตัวตนของบัญชีที่มีการจำกัดวงเงินในการทำธุรกรรมตามระดับการยืนยัน ซึ่งข้อกำหนดเหล่านี้มีไว้เพื่อช่วยในการ:',
  verification_help: 'ข้อกำหนดเหล่านี้ช่วย :',
  why_are_account_tiers_important: 'เหตุใดระดับบัญชีจึงสำคัญ?',
  important_reason:
    'ภายใต้พระราชบัญญัติระบบการชำระเงินและกฎหมายป้องกันและปราบปรามการฟอกเงิน (AML/CFT) ในประเทศไทย กระเป๋าเงินอิเล็กทรอนิกส์จะต้องตรวจสอบข้อมูลประจำตัวผู้ใช้ (KYC) และใช้การจำกัดธุรกรรมตามระดับความเสี่ยงของบัญชี',
  prevent_financial_crimes: 'ป้องกันอาชญากรรมทางการเงิน (การฉ้อโกง การฟอกเงิน)',
  secure_your_account: 'รักษาความปลอดภัยบัญชีของคุณ',
  ensure_safe: 'รับรองบริการการชำระเงินที่ปลอดภัยและเป็นไปตามข้อกำหนด',
  account_features: 'คุณสมบัติของบัญชีผู้ใช้',
  account_type: 'ประเภทของบัญชี',
  view_balance: 'ดูยอดเงินคงเหลือ',
  cash_in: 'เงินเข้า',
  payment: 'การชำระเงิน',
  transaction_history: 'ประวัติการทำธุรกรรม',
  receive_money: 'รับเงิน',
  send_money: 'ส่งเงิน',
  age_more_than_15: 'ผู้ใช้งานที่มีอายุ 15 ปีขึ้นไป',
  age_lest_than_15: 'ผู้ใช้งานที่มีอายุต่ำกว่า 15 ปี',
  non_thai_id_card: 'ผู้ใช้งานที่ไม่มีบัตรประชาชน',
  wallet_balance: 'ยอดเงินในกระเป๋าเงิน',
  wallet_dialog_confirm: 'ยืนยันบัญชีของฉัน',
  wallet_dialog_title: 'วงเงินถึงยอดจำกัดของกระเป๋าเงินแล้ว',
  warn_dialog_title: 'เตือนยอดเงินจำกัดของกระเป๋าเงิน',
  dismiss: 'ยกเลิก',
  wallet_dialog_content_left: 'จำนวนเงินที่ทำรายการเกินขีดจำกัดการรับต่อรายการของผู้รับ (สูงสุด: ฿',
  wallet_dialog_content_right: ') กรุณาลดจำนวนเงินลง',
  warn_dialog_content_left: 'ยอดเงินในบัญชี BluePay ของคุณถึงขีดจำกัดที่',
  warn_dialog_content_right: 'กรุณาใช้จ่ายหรือโอนเงินก่อนการเติมเงิน',
  per_transaction: 'ต่อรายการธุรกรรม',
  daily_cumulative: 'ธุรกรรมรายวัน',
  monthly_transaction: 'ธุรกรรมรายเดือน',
  consumption: 'การใช้จ่าย',
  transfer_out: 'โอนออก',
  transfer_in: 'โอนเข้า',
  unlimited: 'ไม่จำกัด',
  please_upload_supporting_documents: 'กรุณาอัปโหลดเอกสารประกอบ',
  upload_image_here: 'อัปโหลดรูปภาพที่นี่',
  please_upload_you_information: 'กรุณายืนยันข้อมูลของคุณ',
  laser_umber: 'หมายเลขหลังบัตร',
  service_agreement_certification: 'นโยบายความเป็นส่วนตัวเกี่ยวกับกระบวนการเพิ่มวงเงินเครดิต',
  could_not_complete_verification: 'เราไม่สามารถดำเนินการยืนยันตัวตนของคุณให้เสร็จสมบูรณ์ได้',
  could_not_complete_verification_content_1: 'เกิดปัญหากับการส่งข้อมูลของคุณ: ',
  could_not_complete_verification_content_2: 'กรุณาแก้ไขข้อมูลของคุณและลองใหม่อีกครั้ง',
  try_again: 'ลองอีกครั้ง',
  submit_for_manual: 'ส่งเพื่อตรวจสอบด้วยตนเองแทน',
  auth_failed: 'การตรวจสอบล้มเหลว',
  failed_reason: 'มีปัญหาเกี่ยวกับ:',
  upload_photo: 'อัปโหลดรูปถ่าย',
  upload_photo_tips: 'อัปโหลดข้อมูลของคุณแล้ว และอยู่ในขั้นตอนการตรวจสอบ.',
  dopa_status_tips:
    'บัญชีของคุณได้รับการอัปเกรดเรียบร้อยแล้ว ขณะนี้คุณสามารถเข้าถึงฟีเจอร์ทั้งหมด และมีวงเงินในการทำธุรกรรมที่สูงขึ้น',
  in_review: 'อยู่ระหว่างการตรวจสอบ',
  supporting_documents: 'เอกสารประกอบ',
  left: 'คงเหลือ',
  used_out_of: 'ใช้ไปจาก ',
  dopa_success: 'การตรวจสอบสำเร็จ!',
  dopa_success_content:
    'บัญชีของคุณได้รับการอัปเกรดเรียบร้อยแล้ว ขณะนี้คุณสามารถเข้าถึงฟีเจอร์ทั้งหมด และมีวงเงินในการทำธุรกรรมที่สูงขึ้น',
  dopa_review: 'ข้อมูลของคุณอยู่ภายใต้การตรวจสอบ.',
  dopa_review_content1:
    'เวลาทำการของเราคือเวลา 8:00 น. ถึง 22:00 น. และการส่งคำขอของคุณจะได้รับการดำเนินการภายใน 1 ชั่วโมงในช่วงเวลาทำการ.',
  dopa_review_content2: 'หากต้องการความช่วยเหลืออื่นๆ สามารถติดต่อฝ่ายบริการลูกค้าของเราได้ที่ ',
  you_can_upload_up_to_5_supporting_documents: 'คุณสามารถอัปโหลดเอกสารประกอบได้สูงสุด 5 รายการ',
  view_supported_guidelines: 'ดูบัตรประจำตัวและเอกสารที่รองรับ',
  supported_guidelines: 'บัตรประจำตัวและเอกสารที่รองรับ',
  work_permit_related_documents: 'เอกสารที่เกี่ยวข้องกับใบอนุญาตทำงาน',
  work_permit_book: 'ใบอนุญาตทำงาน',
  work_permit_card: 'ใบอนุญาตทำงาน(บัตร)',
  work_permit_passport: 'หนังสือเดินทางพร้อมหน้าวีซ่าประเภทคนต่างด้าว (NON-B)',
  work_permit_receipt: 'ใบเสร็จรับใบอนุญาตทำงาน (สำเนาหรือฉบับจริง)',
  other_acceptable_documents: 'เอกสารอื่นที่สามารถใช้แทนได้',
  other_thai_house: 'ทะเบียนบ้าน',
  other_thai_driving: 'ใบอนุญาตขับขี่',
  other_password_non: 'หนังสือเดินทางพร้อมหน้าวีซ่าประเภทคนต่างด้าว (Non-Immigrant)',
  other_password_student: 'หนังสือเดินทางพร้อมวีซ่านักเรียน',
  other_alien_ident: 'บัตรประจำตัวคนต่างด้าว',
  tips_balance_l: 'ยอดเงินคงเหลือในบัญชี BluePay ของคุณไม่สามารถเกิน ฿',
  tips_balance_r: 'ได้ กรุณาลดจำนวนเงิน หรืออัปเกรดระดับบัญชีก่อน',
  tips_balance_r_highest: '.กรุณาลดจำนวนเงินลงหรือใช้ยอดเงินก่อน',
  tips_single_l: 'จำนวนธุรกรรมเกินวงเงินชำระต่อครั้ง (สูงสุด: ฿',
  tips_daily_l: 'ยอดชำระเงินรายวันถึง ฿',
  tips_amount_limit: '(วงเงิน: ฿ ',
  tips_amount_remain: ', คงเหลือ: ฿',
  tips_daily_r: ') หากดำเนินการต่อจะทำให้เกินวงเงิน กรุณาอัปเกรดบัญชีของคุณเพื่อเพิ่มวงเงิน',
  tips_tran_r_highest: ') การดำเนินการต่อจะทำให้เกินวงเงิน',
  tips_monthly_l: 'ยอดชำระเงินรายเดือนถึง ฿',
  tips_monthly_r: ') หากดำเนินการต่อจะทำให้เกินวงเงิน กรุณาอัปเกรดบัญชีของคุณเพื่อเพิ่มวงเงิน',
  powered_by_bluepay: 'ให้บริการโดย BluePay',
  settle_shipments_quickly: 'ดำเนินการจัดส่งสินค้าให้รวดเร็ว',
  with_j_t_bill: 'J&T Bills คุณสามารถชำระเงินการจัดส่งของคุณได้อย่างรวดเร็วและง่ายดาย ด้วย J&T Bills',
  document_expired: 'เอกสารหมดอายุ',
  document_expired_tips: 'เอกสารที่คุณส่งมาหมดอายุแล้ว กรุณาอัปโหลดเอกสารที่ยังใช้ได้และลองใหม่อีกครั้งค่ะ',
  top_up_two_tips_title: 'ระยะเวลาในการดำเนินการ',
  top_up_two_tips_1: 'เวลาทำการ (09:00 – 15:00 น.): เงินจะเข้าภายใน 2 ชั่วโมง',
  top_up_two_tips_2: 'นอกเวลาทำการหรือวันหยุด: เงินจะเข้าภายในเวลา 10:00 น. ของวันทำการถัดไป',
  // PageTitleString
  login: 'เข้าสู่ระบบ',
  register: 'ลงทะเบียน',
  reset_password: 'รีเซ็ตรหัสผ่าน',
  privacy: 'ความเป็นส่วนตัว',
  privacy_agreement: 'ข้อตกลงความเป็นส่วนตัว',
  terms_of_service: 'ข้อตกลงและเงื่อนไข',
  bluepay_service_policy: 'ข้อกำหนดในการให้บริการ BluePay',
  the_special_rules: 'กฎพิเศษสำหรับผู้ใช้',
  service_policy: 'นโยบายการบริการ',
  language: 'ภาษา',
  faq: 'คำถามที่พบบ่อย',
  bank_accounts: 'บัญชีธนาคาร',
  help_center: 'ศูนย์ช่วยเหลือ',
  feedback: 'ข้อเสนอแนะ',
  feedback_history: 'ประวัติข้อเสนอแนะ',
  page_not_found: 'ไม่พบหน้า',
  new_account: 'สร้างบัญชีใหม่',
  personal_information: 'ข้อมูลส่วนบุคคล',
  top_up: 'เติมเงิน',
  cash_out: 'ถอนเงิน',
  transfer: 'การโอนเงิน',
  mobile_top_up: 'เติมเงินโทรศัพท์มือถือ',
  mobile_number: 'หมายเลขโทรศัพท์มือถือ',
  verification_code: 'รหัสยืนยัน',
  mobile_verification: 'การตรวจสอบโทรศัพท์มือถือ',
  update_mobile_number: 'อัปเดตหมายเลขโทรศัพท์มือถือ',
  activate_auto_debit: 'เปิดใช้งานการหักบัญชีอัตโนมัติ',
  jt_bills: 'บิล J&T',
  bill_details: 'รายละเอียดบิล',
  bill_payment_history: 'ประวัติการชำระบิล',
  bill_payment_detail: 'รายละเอียดการชำระบิล',
  assets: 'บัญชีของฉัน',
  transactions: 'ธุรกรรมของฉัน',
  home: 'หน้าหลัก',
  account: 'บัญชี',
  inbox: 'กล่องข้อความ',
  account_limits: 'ข้อจำกัดของบัญชี',
  verification_levels: 'ระดับการยืนยัน',
  account_verification: 'การยืนยันบัญชี',
  you_have_no_data_yet: 'คุณยังไม่มีข้อมูล',
  feedback_successful:
    'ขอขอบคุณที่ส่งความคิดเห็นของคุณเข้าสู่ระบบเรียบร้อยแล้ว เราได้รับข้อมูลเรียบร้อยและจะแจ้งความคืบหน้าของปัญหาให้คุณทราบ หากคุณมีคำถามเพิ่มเติม สามารถติดต่อเราผ่านช่องทางต่อไปนี้ได้เลย: csr@bluepay.asia',
  cancel: 'ยกเลิก',
  no_promotions_available: 'ไม่มีโปรโมชั่นที่สามารถใช้ได้ในขณะนี้',
  all_of_promos: 'โปรโมชั่นทั้งหมดของคุณจะแสดงที่นี่',
  fee_prefix_cash_out: 'จำนวนครั้งถอนเงินฟรีที่เหลือ',
  fee_prefix_transfer_out: 'จำนวนครั้งการโอนเงินฟรีที่เหลือ',
  this_month_0: 'ในเดือนนี้: 0 ครั้ง',
  this_week_0: 'ในสัปดาห์นี้: 0 ครั้ง',
  today_0: 'วันนี้: 0 ครั้ง',
  total_remain: '(คงเหลือทั้งหมด: {a}/{x} ครั้ง)',
  this_week_month: '(จำนวนครั้งที่เหลือในเดือนนี้: {a}/{x} ครั้ง)',
  today_month: '(จำนวนครั้งที่เหลือในเดือนนี้: {a}/{x} ครั้ง)',
  today_week: '(จำนวนครั้งที่เหลือในสัปดาห์นี้: {a}/{x} ครั้ง)',
  today_left: 'วันนี้: {x} ครั้ง',
  total: '{a}/{x} ครั้ง',
  cash_out_this_month_0_total: 'จำนวนครั้งถอนเงินฟรีที่เหลือในเดือนนี้: 0 ครั้ง',
  cash_out_this_week_0_total: 'จำนวนครั้งถอนเงินฟรีที่เหลือในสัปดาห์นี้: 0 ครั้ง',
  cash_out_today_0_total: 'จำนวนครั้งถอนเงินฟรีที่เหลือวันนี้: 0 ครั้ง',
  cash_out_total: 'จำนวนครั้งถอนเงินฟรีที่เหลือ: {a}/{x} ครั้ง',
  cash_out_this_month_0: 'จำนวนครั้งถอนเงินฟรีที่เหลือในเดือนนี้: 0 ครั้ง',
  cash_out_this_month_x: 'จำนวนครั้งถอนเงินฟรีที่เหลือในเดือนนี้: {x} ครั้ง',
  cash_out_this_week_0_month_remain: 'จำนวนครั้งถอนเงินฟรีที่เหลือในสัปดาห์นี้: 0 ครั้ง',
  cash_out_this_week_0: 'จำนวนครั้งถอนเงินฟรีที่เหลือในสัปดาห์นี้: 0 ครั้ง',
  cash_out_this_week_x: 'จำนวนครั้งถอนเงินฟรีที่เหลือในสัปดาห์นี้: {x} ครั้ง',
  cash_out_today_0_month_remain: 'จำนวนครั้งถอนเงินฟรีที่เหลือในวันนี้: 0 ครั้ง',
  cash_out_today_0_week_remain: 'จำนวนครั้งถอนเงินฟรีที่เหลือในวันนี้: 0 ครั้ง',
  cash_out_today_0: 'จำนวนครั้งถอนเงินฟรีที่เหลือในวันนี้: 0 ครั้ง',
  cash_out_today_x: 'จำนวนครั้งถอนเงินฟรีที่เหลือในวันนี้: {x} ครั้ง',
  transfer_out_this_month_0_total: 'จำนวนครั้งการโอนเงินฟรีที่เหลือในเดือนนี้: 0',
  transfer_out_this_week_0_total: 'จำนวนครั้งการโอนเงินฟรีที่เหลือสัปดาห์นี้: 0',
  transfer_out_today_0_total: 'จำนวนครั้งการโอนเงินฟรีที่เหลือวันนี้: 0',
  transfer_out_total: 'จำนวนครั้งการโอนเงินฟรีที่เหลือ: {a}/{x}',
  transfer_out_this_month_0: 'จำนวนครั้งการโอนเงินฟรีที่คงเหลือในเดือนนี้: 0 ครั้ง',
  transfer_out_this_month_x: 'จำนวนครั้งการโอนเงินฟรีที่คงเหลือในเดือนนี้: {x} ครั้ง',
  transfer_out_this_week_0_month_remain: 'จำนวนครั้งการโอนเงินฟรีที่คงเหลือในสัปดาห์นี้: 0 ครั้ง',
  transfer_out_this_week_0: 'จำนวนครั้งโอนเงินฟรีที่คงเหลือในสัปดาห์นี้: 0 ครั้ง',
  transfer_out_this_week_x: 'จำนวนครั้งโอนเงินฟรีที่คงเหลือในสัปดาห์นี้: {x} ครั้ง',
  transfer_out_today_0_month_remain: 'จำนวนครั้งการโอนเงินฟรีที่คงเหลือในวันนี้: 0 ครั้ง',
  transfer_out_today_0_week_remain: 'จำนวนครั้งการโอนเงินฟรีที่คงเหลือในวันนี้: 0 ครั้ง',
  transfer_out_today_0: 'จำนวนครั้งการโอนเงินฟรีที่คงเหลือในวันนี้: 0 ครั้ง',
  transfer_out_today_x: 'จำนวนครั้งการโอนเงินฟรีที่คงเหลือในวันนี้: {x} ครั้ง',
  network_error_toast_1: 'เกิดข้อผิดพลาดในการเชื่อมต่อเครือข่าย กรุณาเปลี่ยนเครือข่ายแล้วลองใหม่!',
  network_error_toast_2: 'ข้อมูลการเข้าสู่ระบบหมดอายุแล้ว!',
  network_error_toast_3: 'ต้องได้รับสิทธิ์ในการเข้าถึง',

  transaction_proof: 'หลักฐานการทำธุรกรรม',
  company_information: 'ข้อมูลบริษัท',
  director_or_an_authorized: 'คุณเป็นกรรมการบริษัทหรือตัวแทนที่ได้รับอนุญาตหรือไม่?',
  company_legal_name: 'ชื่อบริษัทตามกฎหมาย',
  product_service_description: 'รายละเอียดสินค้า/บริการ',
  company_website: 'เว็บไซต์บริษัท',
  tax_identification_number: 'หมายเลขประจำตัวผู้เสียภาษี',
  dbd_document: 'หนังสือรับรองบริษัท',
  primary_director_information: 'ข้อมูลกรรมการ',
  authorized_person_information: 'ข้อมูลผู้มีอำนาจลงนาม',
  valid_id_document: 'เอกสารยืนยันตัวตนที่ถูกต้อง',
  for_thai_nationals: 'สำหรับคนไทย: กรุณาอัปโหลดบัตรประชาชนไทย',
  for_foreigners: 'สำหรับชาวต่างชาติ: กรุณาอัปโหลดหนังสือเดินทาง',
  id_front_image: 'ภาพด้านหน้าบัตรประจำตัว',
  id_back_image: 'ภาพด้านหลังบัตรประจำตัว',
  bank_account_proof: 'หลักฐานบัญชีธนาคาร',
  settlement_account_information: 'ข้อมูลบัญชีสำหรับการชำระเงิน',
  registered_address: 'ที่อยู่จดทะเบียน',
  business_address: 'ที่อยู่สถานประกอบการ',
  director: 'กรรมการ',
  authorized_representative: 'ผู้แทนที่ได้รับอนุญาต',
  not_required_with_passport: 'ไม่จำเป็นต้องใช้หากคุณได้อัปโหลดหนังสือเดินทางแล้ว',
  select_your_account_verification_type: 'เลือกประเภทการยืนยันบัญชีของคุณ',
  enterprise: 'องค์กร',
  personal: 'บุคคล',
  registered_address_same_as_business_address: 'ที่อยู่ที่ลงทะเบียนต้องเหมือนกับที่อยู่ธุรกิจ',
  document_upload_guidelines: 'ข้อแนะนำการอัปโหลดเอกสาร',
  document_upload_guidelines_content_1:
    'กรุณาอัปโหลดรูปถ่ายหรือไฟล์สแกนที่ชัดเจนของเอกสารทะเบียนธุรกิจจากกรมพัฒนาธุรกิจการค้า (DBD) ค่ะ',
  document_upload_guidelines_content_2:
    'เอกสารนี้จะถูกใช้เพื่อการยืนยันตัวตนเท่านั้น และต้องแสดงชื่อบริษัทอย่างเป็นทางการรวมถึงรายละเอียดการจดทะเบียนให้ครบถ้วนค่ะ',
  auth_document_upload_guidelines_content_1:
    'คุณสามารถอัปโหลดเอกสารทางการเงินที่เกี่ยวข้อง เช่น หลักฐานรายการเดินบัญชีธนาคาร ได้ค่ะ',
  auth_document_upload_guidelines_content_2:
    'เอกสารเหล่านี้จะใช้เพื่อยืนยันตัวตนของคุณเท่านั้น โดยเป็นส่วนหนึ่งของกระบวนการลงทะเบียนค่ะ',
  please_select_your_region: 'กรุณาเลือกภูมิภาค',
  download_template: 'ดาวน์โหลดเทมเพลต',
  download_template_img: 'ดาวน์โหลดแบบฟอร์ม (รูปภาพ)',
  download_template_pdf: 'ดาวน์โหลดแบบฟอร์ม (PDF)',
  copy_template_link: 'Copy this link to download the template',
  front_only: 'เฉพาะด้านหน้า',
  front_and_back: 'ด้านหน้าและด้านหลัง',
  thai_national_id_card: 'บัตรประจำตัวประชาชนไทย',
  authorization_document: 'หนังสือมอบอำนาจ',
  please_select: 'กรุณาเลือก',
  please_upload: 'กรุณาอัปโหลด',
  please_select_image: 'Please select image',
  enterprise_service_agreement_certification: 'การรับรองข้อตกลงการให้บริการ',
  please_confirm_that_your_id_type: 'กรุณายืนยันประเภทของเอกสารระบุตัวตนของคุณ：',
  Service_Agreement_Certification: 'การรับรองข้อตกลงการให้บริการ',
  add_bank_account: '+ เพิ่มบัญชีธนาคาร',
  enterprise_accounts: 'สำหรับบัญชีธุรกิจ',
  for_thailand_enterprise: 'สำหรับธุรกิจในประเทศไทย',
  personal_accounts: 'สำหรับบัญชีส่วนบุคคล',
  document_need: 'เอกสารนี้ต้องยื่นในกรณีที่ผู้ลงทะเบียนไม่ใช่กรรมการของบริษัท',
  document_procedure: 'ขั้นตอนการดำเนินการ:',
  copy_document_notice_1: '1.คัดลอกลิงก์ไปวางในเบราว์เซอร์เพื่อดาวน์โหลดแบบฟอร์ม',
  download_document_notice_1: '1.ดาวน์โหลดแบบฟอร์ม (รองรับไฟล์ PDF/รูปภาพ)',
  document_notice_2: '2.กรอกข้อมูลในแบบฟอร์มและประทับตราบริษัท',
  document_notice_3:
    '3.สแกนหรือถ่ายภาพแล้วอัปโหลด (ตรวจสอบให้แน่ใจว่าข้อความชัดเจนและตราประทับอ่านได้; รองรับไฟล์ JPG/PNG)',
  copy_success: 'คัดลอกสำเร็จ โปรดเปิดเบราว์เซอร์ของคุณเพื่อดาวน์โหลด',
  copy_fail: 'คัดลอกล้มเหลว โปรดลองอีกครั้งในภายหลัง',
  // 注销账户相关
  deactivate_account: 'การระงับการใช้งานบัญชี',
  pop_deactivate_title: 'การระงับการใช้งานบัญชี',
  pop_deactivate_account_content_start: 'ก่อนที่คุณจะปิดใช้งานบัญชี โปรดอ่านข้อกำหนดต่อไปนี้อย่างรอบคอบ:',
  pop_deactivate_account_content_1:
    'เมื่อคุณเลือกปิดใช้งานบัญชี บัญชีและข้อมูลทั้งหมดที่เกี่ยวข้อง รวมถึงข้อมูลส่วนบุคคล การตั้งค่า ประวัติการใช้งาน ฯลฯ จะถูกลบอย่างถาวร โปรดพิจารณาให้รอบคอบก่อนตัดสินใจ',
  pop_deactivate_account_content_2:
    'จะมีระยะเวลารอ 90 วันหลังจากปิดใช้งานบัญชี เมื่อสิ้นสุดระยะเวลานี้ คุณจะไม่สามารถเข้าสู่ระบบแอปพลิเคชันได้อีก โปรดตรวจสอบให้แน่ใจว่าคุณไม่ต้องการใช้บัญชีและข้อมูลนี้อีกต่อไป',
  pop_deactivate_account_content_3:
    'หากคุณเข้าสู่ระบบแอปภายใน 90 วัน ขั้นตอนการปิดใช้งานบัญชีจะถูกยกเลิก และบัญชีของคุณจะไม่ถูกปิดใช้งาน คุณจะต้องเริ่มขั้นตอนการปิดใช้งานใหม่อีกครั้ง',
  pop_deactivate_account_content_4:
    'เราให้ความสำคัญกับความเป็นส่วนตัวและความปลอดภัยของข้อมูลของคุณ หลังจากปิดใช้งานบัญชีแล้ว เราจะไม่เก็บข้อมูลส่วนบุคคลของคุณไว้อีก',
  pop_deactivate_account_content_5:
    'หากคุณต้องการใช้บริการของเราในอนาคต คุณจำเป็นต้องลงทะเบียนบัญชีใหม่ บัญชีและข้อมูลเดิมจะไม่สามารถใช้งานได้อีก ก่อนปิดใช้งานบัญชี โปรดสำรองข้อมูลสำคัญของคุณไว้ หากคุณมีคำถามหรือต้องการความช่วยเหลือเกี่ยวกับขั้นตอนการปิดใช้งานบัญชี โปรดติดต่อฝ่ายบริการลูกค้าของเรา',
  pop_deactivate_account_content_end: 'ขอบคุณที่เลือกใช้บริการของเรา!',
  cannot_be_deactivated: 'ไม่สามารถปิดการใช้งานบัญชีของคุณได้',
  cannot_be_deactivated_title:
    'เพื่อป้องกันเงินทุนและความปลอดภัยของบัญชีของคุณ บัญชีของคุณไม่สามารถปิดการใช้งานได้ในขณะนี้ เนื่องจากเหตุผลดังต่อไปนี้:',
  cannot_be_deactivated_content: 'ยอดเงินในบัญชีของคุณไม่เป็นศูนย์.',
  ok: 'ตกลง',
  verify: 'ตรวจสอบ',
  exit: 'ออกจากระบบ',
  deactivate_successful: 'ปิดใช้งานบัญชีสำเร็จ',
  deactivate_successful_title: 'บัญชีของคุณได้เข้าสู่ระยะเวลารอ 90 วัน และจะถูกปิดใช้งานโดยอัตโนมัติหลังจากครบ 90 วัน',
  important_information_1:
    'เมื่อคุณเลือกปิดใช้งานบัญชี บัญชีและข้อมูลทั้งหมดที่เกี่ยวข้อง รวมถึงข้อมูลส่วนบุคคล การตั้งค่า ประวัติการใช้งาน ฯลฯ จะถูกลบอย่างถาวร โปรดพิจารณาให้รอบคอบ',
  important_information_2:
    'จะมีระยะเวลารอ 90 วันหลังจากปิดใช้งานบัญชี เมื่อสิ้นสุดระยะเวลานี้ คุณจะไม่สามารถเข้าสู่ระบบแอปพลิเคชันได้อีก โปรดตรวจสอบให้แน่ใจว่าคุณไม่ต้องการใช้บัญชีและข้อมูลนี้อีกต่อไป',
  important_information_3:
    'หากคุณเข้าสู่ระบบแอปภายใน 90 วัน ขั้นตอนการปิดใช้งานบัญชีจะถูกยกเลิก และบัญชีของคุณจะไม่ถูกปิดใช้งาน คุณจะต้องเริ่มขั้นตอนการปิดใช้งานใหม่อีกครั้ง',
  important_information_4:
    'เราให้ความสำคัญกับความเป็นส่วนตัวและความปลอดภัยของข้อมูลของคุณ หลังจากปิดใช้งานบัญชีแล้ว เราจะไม่เก็บข้อมูลส่วนบุคคลของคุณไว้อีก',
  important_information_5:
    'หากคุณต้องการใช้บริการของเราในอนาคต คุณจำเป็นต้องลงทะเบียนบัญชีใหม่ บัญชีและข้อมูลเดิมจะไม่สามารถใช้งานได้อีก',
  verify_it_is_you: 'ตรวจสอบว่าเป็นคุณ',
  enter_your_phone: 'กรอกหมายเลขโทรศัพท์ของคุณเพื่อรับรหัสยืนยัน',
  account_recovery_reminder: 'การแจ้งเตือนการกู้คืนบัญชี',
  account_reactivated_content: 'คุณได้หยุดกระบวนการยกเลิกบัญชี บัญชีของคุณได้รับการกู้คืนแล้ว',

  registrant_identity_confirmation: 'การยืนยันตัวตนของผู้ลงทะเบียน',
  proceed_to_verification: 'ดำเนินการต่อไปยังขั้นตอนการยืนยันตัวตน',
  submit_success: 'การตรวจสอบสำเร็จ! ',
  submit_success_content1: 'เราได้รับข้อมูลของคุณแล้ว และกำลังอยู่ระหว่างการตรวจสอบ',
  submit_success_content2:
    'ทีมงานของเราดำเนินการตรวจสอบการส่งข้อมูลระหว่างเวลา 08:00 น. ถึง 22:00 น. และจะตรวจสอบข้อมูลของคุณภายใน 1 ชั่วโมงในช่วงเวลานี้',
  submit_success_content3: 'หากมีคำถามหรือข้อสงสัยใด ๆ สามารถติดต่อเราได้ที่:',
  enhanced_kyc_requires_verification: 'การตรวจสอบตัวตนขั้นสูง จำเป็นต้องมีการยืนยันข้อมูลของผู้ลงทะเบียน',
  please_confirm_that_you_are: 'กรุณายืนยันว่าคุณเป็น:',
  top_up_time_toast: 'ภายใน 2 ชั่วโมงทำการ',
  continue: 'ดำเนินการต่อ',

  face_authentication: 'ยืนยันตัวตนด้วยใบหน้า',
  verification_failed: 'การตรวจสอบล้มเหลว',
  verification_failed_tips:
    'การยืนยันตัวตนล้มเหลว โปรดยืนยันว่าคุณคือ: {name} หมายเลขบัตรประชาชนคือ: {id}， หากข้อมูลของคุณไม่ถูกต้อง โปรดยื่นคำขอตรวจสอบด้วยตนเอง.',
  submit_for_manual_review: 'ส่งคำขอตรวจสอบด้วยตนเอง',
  manual_review_request: 'คำขอตรวจสอบด้วยตนเอง',
  select_reason_for_appeal: 'โปรดเลือกเหตุผลในการยื่นอุทธรณ์ของคุณ:',
  incorrect_name_or_ID: 'กรอกชื่อหรือหมายเลขบัตรประชาชนไม่ถูกต้อง',
  incorrect_document_information: 'ข้อมูลเอกสารไม่ถูกต้อง',
  other_reasons: 'เหตุผลอื่น ๆ',
  submit_request: 'ส่งคำขอ',
  set_up_pin: 'ตั้งรหัส PIN',
  remind_me_later: 'เตือนฉันในภายหลัง',
  pop_set_pin_content: 'เพื่อเพิ่มความปลอดภัยในการทำธุรกรรมของคุณ โปรดตั้งรหัส PIN สำหรับบัญชีของคุณ',
  issue_13_tips: 'โปรดอัปโหลดเอกสารยืนยันตัวตนที่คุณใช้ในการลงทะเบียน พร้อมรูปถ่ายของคุณที่ถือเอกสารนั้น',
  face_required_tips: 'การตั้งรหัส PIN สำหรับการชำระเงินจำเป็นต้องใช้การยืนยันตัวตนด้วยใบหน้า',
  otp_required_tips: 'การตั้งค่ารหัส PIN จำเป็นต้องมีการยืนยันด้วยรหัส OTP.',
  create_your_pin_for: 'โปรดตั้งรหัส PIN แบบ 6 หลักสำหรับบัญชีของคุณ.',
  create_your_pin_confirm: 'โปรดยืนยันรหัส PIN แบบ 6 หลักของคุ.',
  pin_no_match: 'รหัส PIN ไม่ตรงกัน โปรดป้อนใหม่อีกครั้ง。',
  pin_setup_complete: 'ตั้งค่า PIN เสร็จสมบูรณ์',
  pin_setup_complete_content:
    'ขอแสดงความยินดี! การตั้งค่ารหัส PIN ของคุณเสร็จสมบูรณ์แล้ว ขณะนี้การชำระเงินของคุณมีความปลอดภัยยิ่งขึ้น',
  done: 'เสร็จสิ้น',
  set_now: 'ตั้งค่าทันที',
  forgot_pin: 'ลืมรหัส PIN?',
  user_face_pay: 'ใช้การยืนยันตัวตนด้วยใบหน้า',
  enter_pin: 'ป้อนรหัส PIN',
  enter_payment_pin: 'โปรดป้อนรหัส PIN แบบ 6 หลัก。',
  please_complete_face: 'เพื่อเพิ่มความปลอดภัยในการทำธุรกรรมของคุณ โปรดทำการยืนยันตัวตนด้วยใบหน้า',
  verification_code_to_phone: 'กรอกรหัสยืนยันที่ส่งไปยังโทรศัพท์ของคุณ',
  verify_old_pin: 'ยืนยัน PIN เดิม',
  input_your_old_pin: 'กรุณากรอก PIN เดิมของคุณ',
  verify_with_old_pin: 'ยืนยันด้วย PIN เดิม',
  facial_authentication: 'การยืนยันด้วยใบหน้า',
  otp_verification: 'ยืนยัน OTP',
  pin_verification_method: 'เพื่อความปลอดภัยของคุณ โปรดยืนยันตัวตนก่อนตั้งค่า PIN ใหม่ เลือกวิธีการยืนยันที่คุณต้องการ',
  face_try_again_later:
    'การยืนยันตัวตนด้วยใบหน้าล้มเหลวหลายครั้งเกินไป ฟีเจอร์นี้ถูกล็อกชั่วคราว โปรดลองอีกครั้งในอีก {time} นาที',
  not_now: 'ยังไม่ใช่ตอนนี้',
  upgrade_to_unlock: 'อัปเกรดเพื่อปลดล็อก',
  forgot_to_unlock:
    'ระบบได้ทำการล็อคบัญชีชั่วคราว เนื่องจากคุณป้อนรหัส PIN ไม่ถูกต้องหลายครั้งเกินไป กรุณากดปุ่ม "ลืมรหัส PIN" และดำเนินการยืนยันตัวตนด้วยใบหน้าเพื่อเปิดใช้งานบัญชีอีกครั้ง',
  upgrade_to_unlock_pin:
    'คุณป้อนรหัส PIN ผิดหลายครั้งเกินไป บัญชีของคุณถูกล็อกแล้ว เพื่อความปลอดภัยของบัญชี โปรดทำการยืนยันตัวตนเพื่ออัปเกรดให้เสร็จสิ้น เมื่อการยืนยันเสร็จสิ้น รหัส PIN ของคุณจะถูกปลดล็อกโดยอัตโนมัติ และวงเงินในการทำธุรกรรมของคุณจะเพิ่มขึ้น',
  upgrade_to_unlock_pin_in_audit:
    'คำขอรีเซ็ตรหัส PIN และอัปเกรดบัญชีของคุณกำลังอยู่ระหว่างการตรวจสอบ\n' +
    '\n' +
    'คุณจะไม่สามารถทำธุรกรรมได้จนกว่าการอนุมัติจะเสร็จสมบูรณ์ ทีมงานของเราดำเนินการตรวจสอบคำขอระหว่างเวลา 08:00 น. ถึง 22:00 น. และมุ่งมั่นที่จะตรวจสอบคำขอของคุณภายใน 1 ชั่วโมงในช่วงเวลาดังกล่าว\n' +
    '\n' +
    'หากมีคำถามเพิ่มเติม สามารถติดต่อเราได้ที่:\n' +
    'onboard@bluepay.asia',
  please_complete_facial: 'เพื่อเพิ่มความปลอดภัยในการทำธุรกรรมของคุณ โปรดทำการยืนยันตัวตนด้วยใบหน้า',
  your_facial_authentication_is_undergoing_review:
    'การยืนยันตัวตนด้วยใบหน้าของคุณกำลังอยู่ระหว่างการตรวจสอบ คุณจะยังไม่สามารถทำธุรกรรมได้จนกว่าการอนุมัติจะเสร็จสิ้น ทีมงานของเราดำเนินการตรวจสอบคำขอระหว่างเวลา 08.00 น. ถึง 22.00 น. และเรามุ่งมั่นที่จะตรวจสอบคำขอของคุณให้เสร็จภายใน 1 ชั่วโมงในช่วงเวลาดังกล่าว หากมีคำถามเพิ่มเติม สามารถติดต่อเราได้ที่: onboard@bluepay.asia',
  pin_must_be: 'รหัส PIN ต้องเป็นตัวเลข 6 หลักที่ไม่เรียงลำดับต่อกันและไม่มีตัวเลขซ้ำ',
  face_fail_to_try_again: 'การยืนยันตัวตนด้วยใบหน้าล้มเหลว กรุณาลองใหม่อีกครั้ง',
  pin_unlocked_successfully: 'ปลดล็อกรหัส PIN สำเร็จแล้ว คุณสามารถดำเนินการทำธุรกรรมต่อได้.',
  large_trans_tip:
    'รายการธุรกรรมที่มีมูลค่าสูงจำเป็นต้องมีการยืนยันตัวตนด้วยการสแกนใบหน้า เพื่อปกป้องความปลอดภัยของธุรกรรมของคุณ กรุณาดำเนินการยืนยันการอัปเกรดบัญชีให้สมบูรณ์ค่ะ',
  pin_unlock_success: 'การรีเซ็ตรหัส PIN และการอัปเกรดบัญชีของคุณเสร็จสมบูรณ์แล้ว ขณะนี้คุณสามารถดำเนินการทำธุรกรรมได้',
  ...privacy,
  ...termsOfService,
  ...spacialRules,
  ...protocol,
  ...kycPrivacy,
  ...serviceCertification
}

export default th
